// extracted by mini-css-extract-plugin
export default {"toolbar":"src-feature-ui-calendar-__calendar_toolbar","calendar":"src-feature-ui-calendar-__calendar_calendar"};